












































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import FootView from '@/pages/goods-new/comps/FootView.vue'
import * as _ from 'underscore'
import { addStatistics } from '../pages/goods-new/require'
@Component({
  components: {
    FootView,
    // ViewFooter: () => import('../goods/viewFooter2.vue'),
  },
})
export default class LevelShow extends Vue {
  @Prop() visible: boolean
  @Prop() type: any
  @Prop() close: any
  @Prop() spuData: any
  @Prop() skuData: any
  @Prop() curLevel: any
  @Prop() buttonName: any
  @Prop() changeLevel
  @Prop() skuActivity: any
  @Prop() attrData: any
  @Prop() activityNames: any
  @Prop() goldShow: boolean
  @Prop() goldData: any
  @Prop() goldDiscount: boolean
  @Prop() goodsStatus: string
  discountData: any = {}
  typeMap = {
    presell: '定金预售',
    limit_buy: '限时折扣',
    group: '限时拼团',
    limit_free: '限时免费',
    will_sale: '即将开售',
    will_out: '即将停售',
    is_out: '已下架',
  }
  isOpen: boolean = false
  // level: any = this.curLevel ? JSON.parse(JSON.stringify(this.curLevel)) : {}
  level: any = {}
  limit_buy: any = {}
  show() {
    this.isOpen = !this.isOpen
  }
  get discountTypeName() {
    let limitBuyType =
      this.discountData && this.discountData.tag === '限时报名'
        ? '限时报名'
        : '限时折扣'
    let type = this.discountData.activity_type
    let lastname =
      (type === 'limit_buy' ? limitBuyType : this.typeMap[type]) || ''
    if (lastname === '') {
      if (
        this.level.activities &&
        this.level.activities.gift &&
        Object.keys(this.level.activities.gift).length !== 0
      ) {
        lastname = '买赠活动'
      }
    }
    return lastname
  }
  get showOriginSalePrice() {
    if (this.discountTypeName !== '') {
      return true
    } else {
      return false
    }
  }
  get gifts() {
    if (
      this.level.activities &&
      this.level.activities.gift &&
      this.level.activities.gift.giftList &&
      _.isEmpty(
        _.intersection(['group', 'presell', 'channel'], this.activityNames)
      )
    ) {
      return this.level.activities.gift.giftList || []
    } else {
      return this.level.gifts || []
    }
  }
  get salePrice() {
    console.log('价格', this.level, this.spuData)
    let price = this.level.salePrice
    if (
      this.level.giftsActivity &&
      this.level.giftsActivity.gift &&
      _.isEmpty(
        _.intersection(
          ['group', 'presell', 'limit_buy', 'channel'],
          this.activityNames
        )
      )
    ) {
      // 无其他有更改价格活动时 使用赠品活动改价功能
      price = this.level.giftsActivity.activity_price
    }
    if (this.level.channel_activity) {
      return this.level.activityPrice
    }
    if (this.level.id) {
      return price
    }
    return this.limit_buy.id
      ? this.limit_buy.sale_price
      : this.spuData.sale_price
  }
  get popupVisible() {
    return this.visible
  }
  get profitRange() {
    let profitArr = this.skuData.filter(v => v.profit)
    if (!profitArr.length) {
      return false
    }
    profitArr = profitArr.map(x => +x.profit)
    let max = Reflect.apply(Math.max, null, profitArr)
    let min = Reflect.apply(Math.min, null, profitArr)
    return min === max
      ? `${min.toFixed(2)}`
      : `${min.toFixed(2)}-${max.toFixed(2)}`
  }
  get scaleRange() {
    let scaleArr = this.skuData.filter(v => v.scale)
    if (!scaleArr.length) {
      return false
    }
    scaleArr = scaleArr.map(x => +x.scale * 100)
    let max = Reflect.apply(Math.max, null, scaleArr)
    let min = Reflect.apply(Math.min, null, scaleArr)
    return min === max
      ? `${min.toFixed(0)}`
      : `${min.toFixed(0)}-${max.toFixed(0)}`
  }
  get giftsFilter() {
    return this.gifts.filter(item => !!item.is_show_gift)
  }
  created() {
    this.level = this.curLevel
    this.discountData = this.skuActivity[this.level.id] || {}
  }
  levelHandle(item) {
    // 埋点 点击规格
    addStatistics({
      event: 'Click_Specification_H5',
      p1: this.$route.query.spuId + '_' + item.id || '',
      p2: item.id,
      p3: this.goodsStatus,
    })
    console.log(item)
    // if (!item.id) item = 0
    if (item && item.virtual_inventory_qty <= 0) {
      return
    }
    // if (item.id === this.level.id) {
    //   item = {}
    // }
    this.level = item
    this.limit_buy =
      Object.keys(this.skuActivity).length &&
      this.skuActivity[this.level.id] &&
      this.skuActivity[this.level.id].activity_type === 'limit_buy'
        ? this.skuActivity[this.level.id]
        : {}
    let skuId = this.level ? this.level.id : ''
    this.discountData = this.skuActivity[skuId] || {}

    this.changeLevel(item)
  }
  hide(r) {
    this.close(r)
  }
}
